import React, { useState } from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../theme';
import Tick from '../../../assets/tick.svg';
import { useField } from 'formik';
const getCheckedStyles = (checked, type) => {
    if (type === 'checkbox') {
        return {
            content: `url("${Tick}")`,
            top: '46%',
            left: '50%',
            height: 'auto',
            display: checked ? 'block' : 'none',
            transform: 'translate(-50%, -50%)',
        };
    }
    return {
        content: "''",
        display: checked ? 'block' : 'none',
        left: '50%',
        top: '50%',
        border: '4px solid white',
        borderRadius: '100%',
        transform: 'translate(-50%, -50%)',
    };
};
const StyledTitle = styled.span `
	${theme.typography.IR100};
	color: ${theme.colors.LM_NU100};
	line-height: ${theme.typography.lineHeight.md};
	vertical-align: middle;
	user-select: none;
	margin-left: 2rem;
`;
export const StyledIndicator = styled.span `
	position: absolute;
	top: 0;
	left: 0;
	height: 24px;
	width: 24px;

	transition: all 120ms ease-in-out;

	border: solid;
	border-width: ${({ focused }) => (focused ? '2px' : '1px')};

	border-radius: ${({ type }) => type === 'checkbox' ? theme.radii.radii30 : '100%'};

	background-color: ${({ checked, hovered, focused }) => checked
    ? hovered || focused
        ? theme.colors.BB120
        : theme.colors.BB100
    : hovered || focused
        ? theme.colors.LM_NU20
        : theme.colors.LM_NU10};

	border-color: ${({ focused, checked }) => focused
    ? theme.colors.BB80
    : checked
        ? theme.colors.BB120
        : theme.colors.LM_NU30};

	:after {
		position: absolute;

		${({ checked, type }) => (Object.assign({}, getCheckedStyles(checked, type)))}
	}
`;
const StyledLabel = styled.label `
	position: relative;
	display: flex;
	align-items: center;
	margin-bottom: 1rem;
	width: 100%;
	cursor: pointer;
`;
const StyledInput = styled.input `
	all: unset;
	opacity: 0;
	height: 0;
	width: 0;
`;
export const RadioCheck = React.forwardRef((props, ref) => {
    var _a;
    // Formik connector
    // https://formik.org/docs/api/useField
    const [field, meta] = useField(props);
    // Custom & Native HTML props
    const { label, style, hovered } = props;
    /* TODO: AFAIK
     * Using component selectors in styled components enforces the use of Babel for both storybook and
     * consuming applications, which is significant overhead for something we get for free with CSS.
     * Falling back to JS Events for now.
     */
    const [focused, setFocused] = useState(false);
    return (React.createElement("div", { onFocus: () => setFocused(true), onBlur: () => setFocused(false) },
        React.createElement(StyledInput, Object.assign({ "aria-label": props['aria-label'] || label }, field, meta, props, { ref: ref })),
        React.createElement(StyledIndicator, { type: props.type, checked: (_a = field.checked) !== null && _a !== void 0 ? _a : false, focused: focused, hovered: hovered, style: style })));
});
export const RadioCheckInput = (props) => {
    var _a;
    const [hovered, setHovered] = useState(false);
    return (React.createElement(StyledLabel, { onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false), style: props.style, checked: (_a = props.checked) !== null && _a !== void 0 ? _a : false, className: props.className },
        React.createElement(RadioCheck, Object.assign({}, props, { hovered: hovered })),
        React.createElement(StyledTitle, null, props.label)));
};
//# sourceMappingURL=RadioCheckInput.js.map